import {useContext} from "react";
import {CartContext, CartItem} from "../../contexts/CartContext";

export function CartItemIncreasePressables(props: { cartItem: CartItem, viewClass: any } & {[key:string]:any}) {
    const cart = useContext(CartContext);
    return <props.viewClass onPress={() => {
        cart.increase(props.cartItem);
    }} {...props}/>
}

export function CartItemDecreasePressable(props: { cartItem: CartItem, viewClass: any } & {[key:string]:any}) {
    const cart = useContext(CartContext);
    return <props.viewClass onPress={() => {
        cart.decrease(props.cartItem);
    }} {...props}/>
}

export function CartItemDeletePressable(props: { cartItem: CartItem, viewClass: any } & {[key:string]:any}) {
    const cart = useContext(CartContext);
    return <props.viewClass onPress={() => {
        cart.delete(props.cartItem);
    }} {...props}/>
}